const wowApp = require('angular').module('wowApp.common');
wowApp.directive('clearableInputs', ['jQuery', '$log', require('./clearable-inputs-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/clearable-inputs/index.js
 **/